import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../Components/Sidebar/Sidebar";
import verificandoToken from "../../FuncoesGerais/VerificarToken";
import verificandoApp from "../../FuncoesGerais/verificaApp";

import "./ConversorQuebraLinha.css";

function ConversorQuebraLinha() {
    const history = useHistory();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) {
            history.push("/");
        }
    };

    const [fileName, setFileName] = useState("");
    const [fileContent, setFileContent] = useState("");

    useEffect(() => {
        verificar();
        verificandoToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = (event) => {
            let text = event.target.result;
            text = text.replace(/\r/g, "").replace(/\n/g, "\r\n");
            setFileContent(text);
        };
        reader.readAsText(file, "utf-8");
    };

    const handleDownload = () => {
        if (!fileContent) return;

        const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");

        const newName = fileName
            ? fileName.replace(/(\.txt)?$/, "_modificao.txt")
            : "arquivo_modificado.txt";

        a.href = url;
        a.download = newName;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <form>
                <div className="container-fluid titulo">
                    <h1>Quebra de Linha - Arquivo INTER</h1>

                    <div className="col-8">
                        <div className="input-group mb-3">
                            <input
                                type="file"
                                accept=".txt"
                                className="form-control"
                                onChange={handleFileChange}
                            />
                            <button
                                onClick={handleDownload}
                                className="btn btn-secondary"
                                type="button"
                                disabled={!fileContent}
                            >
                                <i className="fas fa-download"></i> Baixar Convertido
                            </button>
                        </div>
                    </div>

                    {fileName && (
                        <div className="mt-3">
                            <h5>Arquivo selecionado: {fileName}</h5>
                            <pre className="preview">{fileContent}</pre>
                        </div>
                    )}
                </div>
            </form>

            <div className="container-fluid d-flex ml-5">
                <Link
                    to="/home"
                    className="btn btn-secondary ms-auto mb-4 mt-3"
                    type="button"
                >
                    Voltar
                </Link>
            </div>
            </main>
        </div>
    );
}

export default ConversorQuebraLinha;
